import app from './app.json';
import common from './common.json';
import page from './page.json';
const th = {
    app,
    common,
    page
};
export default th;
